// extracted by mini-css-extract-plugin
export default {"container":"RegisterForm_container__SrlA+","title":"RegisterForm_title__Y+vAr"};